/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlogPostDto } from '../../models/blog-post-dto';
import { BlogPostShowResponse } from '../../models/blog-post-show-response';

export interface PostBlogPostCreate$Params {
      body: BlogPostDto
}

export function postBlogPostCreate(http: HttpClient, rootUrl: string, params: PostBlogPostCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BlogPostShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postBlogPostCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlogPostShowResponse>;
    })
  );
}

postBlogPostCreate.PATH = '/v1/blog-post';
